import { Trans } from "@lingui/react/macro";
import { type ReactNode, useId } from "react";

// «Коротко»: пересказ документа простыми словами над полным текстом.
export const ShortSummary = ({ children }: { children: ReactNode }) => {
  const headingId = useId();
  return (
    <aside
      aria-labelledby={headingId}
      className="flex flex-col gap-2 rounded-xl border border-border bg-surface px-5 py-4"
    >
      <h2 id={headingId} className="font-display text-[22px] leading-tight text-foreground">
        <Trans>In short</Trans>
      </h2>
      <ul className="flex list-disc flex-col gap-1 pl-5">{children}</ul>
      <p className="text-[13px] text-subtle">
        <Trans>This is a summary. The full text below is what applies.</Trans>
      </p>
    </aside>
  );
};
